import type { Specimen } from "./useSpecimens";
import { CONSUMING_SPECIMEN_USAGES } from "./frozenSpecimenUsages";

/**
 * A stored specimen can be selected for a new consuming cycle only when an
 * open cycle has not already claimed it. Closed-cycle history is retained and
 * does not make the specimen disappear from the inventory.
 */
export function getOpenConsumingCycleId(
  specimen: Pick<Specimen, "specimenUsages">,
  openCycleIds: ReadonlySet<string>,
  allowedCycleId?: string | null,
): string | null {
  const usage = (specimen.specimenUsages ?? []).find(
    (candidate) =>
      candidate.cycleId != null &&
      candidate.cycleId !== allowedCycleId &&
      openCycleIds.has(candidate.cycleId) &&
      CONSUMING_SPECIMEN_USAGES.has(candidate.usage),
  );

  return usage?.cycleId ?? null;
}

export function getSelectionSourceCycleId(
  specimens: readonly Pick<Specimen, "id" | "cycleId">[],
  selectedIds: readonly string[],
): string | null {
  const selected = specimens.find((specimen) =>
    selectedIds.includes(specimen.id),
  );
  return selected?.cycleId ?? null;
}
